import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { isPlatform } from "@ionic/react";
import { PROD_FRONTEND_URL } from "src/config/frontendUrls";

/**
 * Articles-only CTA box (same visual style as trade-share SignUpBanner).
 * Opens rotogpt.com — does not open the payment/membership drawer.
 */
const ArticlesSign: React.FC = () => {
  const isRunningNatively = Capacitor.isNativePlatform() || isPlatform("hybrid");
  const colorApp = PureLightThemeCaaS.colors.alpha.orange[100];

  const handleSignUpClick = async () => {
    const url = PROD_FRONTEND_URL;
    try {
      if (isRunningNatively) {
        await Browser.open({ url, presentationStyle: "popover" });
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("ArticlesSign: Error opening rotogpt.com:", error);
    }
  };

  return (
    <Box
      sx={{
        width: "90%",
        bgcolor: "#000000",
        borderRadius: 2,
        border: `1px solid ${colorApp}`,
        p: 0.5,
        mb: 0,
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: 500,
          textAlign: "center",
          lineHeight: 1.2,
          pt: 0.2,
        }}
      >
        Want to run your own fantasy team analysis?
      </Typography>

      <Button
        variant="contained"
        disableRipple
        onClick={handleSignUpClick}
        sx={{
          width: "180px",
          height: "20px",
          bgcolor: colorApp,
          color: "#ffffff",
          borderRadius: 2,
          px: 2,
          py: 0,
          textTransform: "none",
          fontSize: "14px",
          fontWeight: "bold",
          boxShadow: "none",
          "&:hover": {
            bgcolor: colorApp,
            filter: "brightness(0.9)",
            boxShadow: "none",
          },
          "&:active": {
            bgcolor: colorApp,
            filter: "brightness(0.85)",
            boxShadow: "none",
          },
          "&:focus": {
            bgcolor: colorApp,
            boxShadow: "none",
          },
          "&.Mui-focusVisible": {
            bgcolor: colorApp,
            boxShadow: "none",
            outline: `2px solid ${colorApp}`,
            outlineOffset: 2,
          },
        }}
      >
        Sign up for free
      </Button>
    </Box>
  );
};

export default ArticlesSign;
